import { API_AUTH_PATH } from 'utils/constants'
import Api from './axiosInstance'
import { LoginFormData } from 'components/loginForm'

// To Login user
const userLogin = (data: LoginFormData) => {
  return Api.post({ url: API_AUTH_PATH.LOGIN, data: data })
}

// To validate Token stored in cookie
const verifyToken = () => {
  return Api.get({ url: API_AUTH_PATH.VERIFY_TOKEN })
}

// To Request Forgot Password
const forgotPassword = (data: { email: string }) => {
  return Api.post({ url: API_AUTH_PATH.FORGOT_PASSWORD, data: data })
}

// Verify the given token to change the password
const validateForgotPasswordToken = (token: string) => {
  return Api.post({
    url: `${API_AUTH_PATH.FORGOT_PASSWORD}/${token}`,
  })
}

// Reset password after validate the token
const resetPassword = (data: { id: string; password: string }) => {
  return Api.post({
    url: API_AUTH_PATH.RESET_PASSWORD,
    data,
  })
}

// Logout the user and clear the cookies
const logoutUser = () => {
  return Api.post({ url: API_AUTH_PATH.LOGOUT })
}

export {
  userLogin,
  verifyToken,
  forgotPassword,
  logoutUser,
  resetPassword,
  validateForgotPasswordToken,
}
